export default {
  removeCommas(number) {
    return number.replace(/[^0-9\\.]/g, '')
  },

  addCommas(number) {
    return number.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
}
